






































import { defineComponent, ref, onMounted } from '@nuxtjs/composition-api';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppPrice from '~/components/partials/App/AppPrice.vue';
import { useStore } from '~/composables/useStore';
import { url } from '~/utils';

type SimilarProduct = {
  code: string;
  size: string;
  priceSetting: {
    isRed: boolean;
    lineThroughPrice?: number;
    price?: number;
    excludingTaxPrice?: number;
  };
};

export default defineComponent({
  components: {
    AppLink,
    AppPrice,
  },
  props: {
    productCode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const similarProducts = ref<SimilarProduct[]>([]);

    onMounted(async () => {
      try {
        const response = await store.dispatch('product/detail/fetchSimilarProducts', {
          path: { code: props.productCode },
        });
        similarProducts.value = response
          .map((product) => {
            const { size_amount, size_unit } = product;
            return {
              size: size_amount ? `${size_amount}${size_unit || 'ml'}` : '',
              code: product.code,
              priceSetting: {
                isRed: Boolean(product.special_price_including_tax),
                lineThroughPrice: product.special_price_including_tax && product.best_price_including_tax,
                price: product.special_price_including_tax || product.best_price_including_tax,
                excludingTaxPrice: product.special_price || product.best_price,
              },
            };
          })
          .filter(({ priceSetting }) => !!priceSetting.price);
      } catch {
        // 何もしない
      }
    });

    return {
      similarProducts,
      url,
    };
  },
});
